import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=0e37abc8&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=0e37abc8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e37abc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e37abc8')) {
      api.createRecord('0e37abc8', component.options)
    } else {
      api.reload('0e37abc8', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=0e37abc8&scoped=true", function () {
      api.rerender('0e37abc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/TopMenu/SidebarItem.vue"
export default component.exports